import React from 'react'
import classes from './NotFound.module.sass'
import { Helmet } from 'react-helmet-async'

const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>{`logid - страница не найдена`}</title>
        <meta name="description" content={`404 Not found | Такой страницы не существует`} />
      </Helmet>
      <div className={classes.Container}>404 Not found | Такой страницы не существует</div>
    </>
  )
}

export default NotFound
